export enum PaymentTerms {
    MONTHLY = 12,
    QUARTER = 4,
    HALFYEAR = 2,
    YEAR = 1
}
